module.exports = __webpack_public_path__ + "static/media/logoFace.b604e182.png";